import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhoItsFor } from './components/WhoItsFor';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { WhyChoose } from './components/WhyChoose';
import { MaterialPreview } from './components/MaterialPreview';
import { Countdown } from './components/Countdown';
import { WhatsAppTestimonials } from './components/WhatsAppTestimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    const imgLink = document.createElement('link');
    imgLink.rel = 'preload';
    imgLink.as = 'image';
    imgLink.href = 'https://cdn.magicpatterns.com/uploads/tmoM3QPgSs3tumHqJ5iocx/hf_20260516_163314_aa7428a1-182f-493a-9299-dd713a79f6f8.png';
    document.head.appendChild(imgLink);
  }, []);
  return <main className="w-full min-h-screen bg-chem-bg selection:bg-chem-turquoise/30 selection:text-chem-navy" data-id="element-0" data-mp="3mk83iqmq9x9u">
      <MetaPixel data-id="element-1" data-mp="3rd1bdndhtlq5" />
      <Hero data-id="element-2" data-mp="3reltuemj9e7n" />
      <SocialProof data-id="element-3" data-mp="5yi8qe3h5da" />
      <WhoItsFor data-id="element-4" data-mp="6hpnd64cbd2" />
      <PainPoints data-id="element-5" data-mp="4ww9qvjiygs" />
      <ProductBreakdown data-id="element-6" data-mp="5gbv0xpxarn" />
      <WhyChoose data-id="element-7" data-mp="7st1bvnjh3n" />
      <WhatsAppTestimonials data-id="element-8" data-mp="2zld2jatxbhc2" />
      <MaterialPreview data-id="element-9" data-mp="2zm4xcjfp5b1a" />
      <Countdown data-id="element-10" data-mp="2zmwj72jhrued" />
      <Pricing data-id="element-11" data-mp="2zng0qi58cgrv" />
      <FAQ data-id="element-12" data-mp="33mf2xuzktzfm" />
      <FinalCTA data-id="element-13" data-mp="33m5cy7ej7s9x" />
      <Footer data-id="element-14" data-mp="33nq6put0v76q" />
    </main>;
}